import questionService from '@/api/question'
import marketService from '@/api/question'
import { QUESTION_STATUS } from '@/constants/marketBackendEnums'
import { priceCurrencyIdFor } from '@/features/market/outcome-list/outcomePricing'

export const PLACE_BET_BLOCK_REASON = Object.freeze({
  REAL_MONEY_NOT_AVAILABLE: 'real_money_not_available',
  QUESTION_RESOLVED: 'question_resolved',
  COUNTRY_BLOCKED: 'country_blocked',
  PENDING_RESOLUTION: 'pending_resolution',
  QUESTION_CANCELLED: 'question_cancelled',
  QUESTION_STOPPED: 'question_stopped',
  OUTCOME_RESOLVED: 'outcome_resolved',
  OUTCOME_PAUSED: 'outcome_paused',
  OUTCOME_CANCELLED: 'outcome_cancelled',
  OUTCOME_UNPRICED: 'outcome_unpriced',
  TRADING_PAUSED: 'trading_paused',
})

/**
 * Returns the first place-bet block reason for a question/outcome, or null when betting UI may show.
 * Evaluation order matches PlaceBet.jsx.
 */
export function getPlaceBetBlockReason({ question, outcome, currencyId, fromAllowedCountry, tradingPaused = false }) {
  if (!question) return null

  const isRealMoneyActive = currencyId !== 'OOM'

  if (isRealMoneyActive && question.real_currency_available === false) {
    return PLACE_BET_BLOCK_REASON.REAL_MONEY_NOT_AVAILABLE
  }
  /* `questionService.isResolved` needs RESOLVED, a resolution and `is_wagerable === false`
     together. A list payload can carry the resolution while the flag is still true, and the
     row already draws that market's winner, so the resolution alone settles it here. */
  if (questionService.isResolved(question) || question.resolution != null) {
    return PLACE_BET_BLOCK_REASON.QUESTION_RESOLVED
  }
  if (currencyId !== 'OOM' && !fromAllowedCountry) {
    return PLACE_BET_BLOCK_REASON.COUNTRY_BLOCKED
  }
  if (marketService.isPaused(question) || marketService.isWaitingForResults(question)) {
    return PLACE_BET_BLOCK_REASON.PENDING_RESOLUTION
  }
  if (question.status === QUESTION_STATUS.CANCELLED) {
    return PLACE_BET_BLOCK_REASON.QUESTION_CANCELLED
  }
  if (question.status === QUESTION_STATUS.STOPPED) {
    return PLACE_BET_BLOCK_REASON.QUESTION_STOPPED
  }
  if (outcome?.status === QUESTION_STATUS.RESOLVED) {
    return PLACE_BET_BLOCK_REASON.OUTCOME_RESOLVED
  }
  if (outcome?.status === QUESTION_STATUS.PAUSED) {
    return PLACE_BET_BLOCK_REASON.OUTCOME_PAUSED
  }
  if (outcome?.status === QUESTION_STATUS.CANCELLED || outcome?.disabled) {
    return PLACE_BET_BLOCK_REASON.OUTCOME_CANCELLED
  }
  /* An outcome the payload prices in no currency the market trades has nothing to quote:
     its button reads 0% and the form behind it would price a bet off a missing number. */
  if (outcome?.price && outcome.price[priceCurrencyIdFor(question, currencyId)] === undefined) {
    return PLACE_BET_BLOCK_REASON.OUTCOME_UNPRICED
  }
  if (tradingPaused) {
    return PLACE_BET_BLOCK_REASON.TRADING_PAUSED
  }

  return null
}
